import styled from 'styled-components';
export const CardsContainer = styled.div`
  overflow-y: auto;
  width: 100%;
`;
export const PaymentSection = styled.div`
  border-left: 1px solid #e8e9ed;
  @media (max-width: 910px) {
    border-left: 0;
  }
  flex-direction: column;
  align-items: baseline;
  display: flex;
  padding: 47px;
  min-height: 300px;
`;
export const TextAlert = styled.div`
  color: #414042;
  font-family: 'Proxima Nova';
  font-size: 19px;
  letter-spacing: 0;
  line-height: 16px;
  align-self: baseline;
`;
export const WarningModalWrapper = styled.div`
  padding: 35px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  & > :first-child {
    display: block;
    border-bottom: 1px solid var(--LightGray);
    min-width: max-content;
    margin-bottom: 25px;

    color: rgba(93, 110, 129, 1);
    font-family: 'Proxima Nova';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 12px;
    padding: 12px;
  }
`;

export const EmptyWrapper = styled.div`
  border-bottom: 1px solid rgb(182 192 195 / 45%);
  padding: 0 50px 30px 0;
`;

export const TitleEmpty = styled.h2`
  font-size: 25px;
  margin: 0 0 9px;
`;
